import type { DockMode } from "./types";

export const DEFAULT_DOCK_MODE: DockMode = "expanded";
